import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CheckboxComponent],
  imports: [CommonModule, MatCheckboxModule, MatFormFieldModule, ReactiveFormsModule, FormsModule],
  providers: [],
  exports: [CheckboxComponent],
})
export class CheckboxModule {}
